import React from "react";
import SKUDetails from "../../../components/price-groups/sku.details";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { SKUTempContainer } from "../../../components/price-groups/sku.details/container";
import { GetItemsIdsandSKUsByBrandIdAsync } from "../../../components/items/services";
import { useEffect } from "react";
import Loader from "../../../ui/loader";

export default function SKUEditPage() {
  const dispatch = useDispatch();
  const container = SKUTempContainer(dispatch);
  const { id, brandId } = useParams();
  const skus = useSelector((state) => state.skuTemReducer.skus);
  const initForm = skus.find((item) => item.id == id);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  function ModifyForm(initForm) {
    const customform = {
      id: initForm.id,
      sku: initForm.sku,
      itemId: initForm.itemId,
      reference: initForm.reference,
      quantity: initForm.quantity,
    };
    if (initForm.amount) {
      customform.discountType = "amount";
      customform.amount = initForm.amount;
    } else {
      customform.discountType = "percent";
      customform.amount = initForm.percent;
    }
    return customform;
  }
  const [form, setForm] = useState(ModifyForm(initForm));

  async function GetItemsByBrandId(id) {
    return await GetItemsIdsandSKUsByBrandIdAsync(id);
  }

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        let response = await GetItemsByBrandId(brandId);
        setItems(response.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  function Save() {
    let item = items.find((item) => item.sku == form.sku);
    const sku = {
      id: form.id,
      itemId: item.id,
      sku: form.sku,
      reference: form.reference,
      quantity: form.quantity,
    };

    if (form.discountType == "percent") {
      sku.percent = form.amount;
    } else {
      sku.amount = form.amount;
    }
    container.UpdateSKU(sku);
  }
  return (
    <div>
      {loading ? (
        <Loader></Loader>
      ) : (
        <SKUDetails
          Items={items}
          form={form}
          setForm={setForm}
          Save={Save}
        ></SKUDetails>
      )}
    </div>
  );
}
